// extracted by mini-css-extract-plugin
export default {"lite_btn":"IndexLogo_lite_btn__tT4jJ","lite_btn_brown":"IndexLogo_lite_btn_brown__igSGg"};